import { NotificationSidebarSkeleton } from 'src/features/notifications/components/notification-skeleton/notification-sidebar-skeleton'
import { ChatOutline } from 'src/shared/components/icons/chat/chat-outline'
import { NotificationBell } from 'src/shared/components/icons/notification-bell'
import { Button } from 'src/shared/components/ui/buttons/button'
import { SidebarGroup, SidebarGroupLabel } from 'src/shared/components/ui/miscellaneous/sidebar'
import { Skeleton } from 'src/shared/components/ui/miscellaneous/skeleton'
import { cn } from 'src/shared/utils/cn'

type SectionSkeletonProps = {
  className?: string
}

export const ChatsSectionSkeleton = ({ className }: SectionSkeletonProps) => {
  return (
    <SidebarGroup className="flex min-h-0 flex-col">
      <SidebarGroupLabel className="mb-3 flex items-center justify-between">
        <div className="flex items-center text-lg font-semibold text-primary">
          <ChatOutline className="mr-2.5 size-5" />
          Messages
        </div>
        <Button variant="link" size="sm" className="px-0 text-sm text-primary underline hover:text-muted" disabled>
          See all
        </Button>
      </SidebarGroupLabel>
      <div className={cn('min-h-0 flex-1', className)}>
        <div className="flex flex-col divide-y divide-border overflow-hidden rounded-lg border bg-background">
          {[...Array(5)].map((_, i) => (
            <div key={i} className="flex items-center gap-3 p-3">
              <Skeleton className="size-10 shrink-0 rounded-full" />
              <div className="flex flex-1 flex-col gap-2">
                <Skeleton className="h-4 w-32" />
                <Skeleton className="h-3 w-1/2" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </SidebarGroup>
  )
}

export const NotificationsSectionSkeleton = ({ className }: SectionSkeletonProps) => {
  return (
    <SidebarGroup className="flex min-h-0 flex-col">
      <SidebarGroupLabel className="mb-3 flex items-center justify-between">
        <div className="flex items-center text-lg font-semibold text-primary">
          <NotificationBell className="mr-2.5 size-5" />
          Notifications
        </div>
        <Button variant="link" size="sm" className="px-0 text-sm text-primary underline hover:text-muted" disabled>
          See all
        </Button>
      </SidebarGroupLabel>
      <div className="flex min-h-0 flex-col overflow-hidden rounded-lg border bg-background">
        <div className={cn('flex-1 divide-y divide-border overflow-y-auto', className)}>
          <NotificationSidebarSkeleton />
        </div>
      </div>
    </SidebarGroup>
  )
}
